/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Summary } from '../App.style';

export default () => (
  <>
    <Summary>
      I am reaching out to apply for your Full Stack Developer position at Squla
      in Amsterdam. I am currently a Senior Full Stack Developer at Elsevier
      with 10 years of development experience throughout my career. I like to
      approach problems holistically and pragmatically, solving real issues and
      not just their symptoms. I also have experience in professional education
      and have worked at an education-technology company similar to Squla.
    </Summary>
    <br />
    <Summary>
      I moved to Amsterdam with my wife so she could advance her career.
      Unfortunately this decision meant I had to resign from my position as Lead
      mobile developer at Prodigy Education where I was responsible for the
      mobile versions of the top education game in North America. I helped the
      team improve overall quality by fixing mobile-specific bugs and creating
      internal tools/automation to help Quality Assurance teams be more
      efficient with their time.
    </Summary>
    <br />
    <Summary>
      Before becoming a software developer, my first plan was to be a school
      teacher in Mathematics. I have spent time in classrooms teaching lessons
      and was only 5 months away from graduating as an Ontario Certified Teacher
      (OCT). Eventually I decided software development was a better career path
      for me. However, when I started the position at Prodigy, it felt like an
      amazing place to use both my skills in education and software development.
      I had a unique insight that both developers and product managers valued
      because I could think of myself as a Teacher using the product. At Squla,
      I believe I could provide similar value as a passionate employee of your
      company.
    </Summary>
    <br />
    <Summary>
      After reading through the job description and your company core values, I
      feel like Squla could be a really great fit. Thanks for taking the time to
      learn more about me. I truly hope I have given you enough reasons for more
      consideration. I hope to hear from you soon!
    </Summary>
    <br />
  </>
);
